import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { wardDropdownData } from "./DropDownData";

export const WardDropdown = ({
  value,
  isMulti = false,
  isShowAll = false,
  onSelect,
  selectedId,
  placeholder,
  hospitalId,
  disabled,
  ...props
}) => {
  const [list, setList] = useState();

  useEffect(() => {
    return () => {
      setList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hospitalId) {
      loadWardList();
    }
  }, [hospitalId]);

  const loadWardList = () => {
    wardDropdownData(hospitalId, (data, error) => {
      if (error === null) {
        if (isShowAll === false) {
          setList(data);
        } else {
          let all = {
            id: 0,
            label: "All Ward",
            value: "All",
          };
          setList([all, ...data]);
        }
      }
    });
  };

  useEffect(() => {
    if (selectedId) {
      const selectedOption = list?.find((option) => option.id === selectedId);
      if (selectedOption) {
        onSelect(selectedOption);
      }
    }
  }, [list]);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      disable={disabled}
      value={value ?? (isShowAll ? (list ? list[0] : null) : null)}
      onChange={(e) => {
        if (isShowAll === false) {
          onSelect(e);
        } else {
          e.id === 0 ? onSelect(undefined) : onSelect(e);
        }
      }}
      {...props}
    />
  );
};
